module.exports = __webpack_public_path__ + "files/31456a192c8f2fd16584c543db547eff.png";